(function(){"use strict";try{if(typeof document<"u"){var a=document.createElement("style");a.appendChild(document.createTextNode(".flash-navbar .animated{transition:all .5s cubic-bezier(.05,.7,.1,1)}.flash-navbar .animated.flash-button{width:20px}.flash-navbar .animated.fade-out{transition:all .4s cubic-bezier(.3,0,.8,.15)}.flash-navbar .animated.fade-out-left{width:0;height:0;transform:translate(-100vw)}.flash-navbar .animated.fade-out-right{width:0;height:0;transform:translate(100vw)}.flash-navbar .animated.fade-out-up{transform:translateY(-100vh)}")),document.head.appendChild(a)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { jsx, jsxs } from "react/jsx-runtime";
import { c as classNames } from "../../../../index-e71f83b5.js";
import React__default, { createContext, useState, useEffect } from "react";
import { P as PropTypes, t as tagPropType, m as mapToCssModules } from "../../../../utils-f8d1c624.js";
import FlashButton from "../../../atoms/buttons/FlashButton/FlashButton.js";
import { COMMON_CLASSNAME } from "../../../constants.js";
import { useCollapse } from "../../../../hooks/useCollapse/useCollapse.js";
import { useWindowSize } from "../../../../hooks/useWindowSize/useWindowSize.js";
import "../../../../styles/assets/images/icons/material/designSystem/AccessTime.js";
import "../../../../styles/assets/images/icons/material/designSystem/AccessTimeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/AccountCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/AccountCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Add.js";
import "../../../../styles/assets/images/icons/material/designSystem/AddCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/AddCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/AddLocation.js";
import "../../../../styles/assets/images/icons/material/designSystem/AddLocationFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/AdminPanelSettings.js";
import "../../../../styles/assets/images/icons/material/designSystem/AdminPanelSettingsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Analytics.js";
import "../../../../styles/assets/images/icons/material/designSystem/AnalyticsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Apartment.js";
import "../../../../styles/assets/images/icons/material/designSystem/Apps.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowBack.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowCircleLeft.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowCircleLeftFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowCircleRight.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowCircleRightFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowDownward.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowDropDown.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowDropUp.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowForward.js";
import "../../../../styles/assets/images/icons/material/designSystem/ArrowUpward.js";
import "../../../../styles/assets/images/icons/material/designSystem/Bolt.js";
import "../../../../styles/assets/images/icons/material/designSystem/BoltFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/BugReport.js";
import "../../../../styles/assets/images/icons/material/designSystem/Business.js";
import "../../../../styles/assets/images/icons/material/designSystem/Calculate.js";
import "../../../../styles/assets/images/icons/material/designSystem/CalculateFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/CalendarTodayFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Cancel.js";
import "../../../../styles/assets/images/icons/material/designSystem/CancelFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/CheckCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/CheckCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ChevronLeft.js";
import "../../../../styles/assets/images/icons/material/designSystem/ChevronRight.js";
import "../../../../styles/assets/images/icons/material/designSystem/Circle.js";
import "../../../../styles/assets/images/icons/material/designSystem/CircleFilled.js";
import { ReactComponent as ForwardRef$1 } from "../../../../styles/assets/images/icons/material/designSystem/Close.js";
import "../../../../styles/assets/images/icons/material/designSystem/CoPresent.js";
import "../../../../styles/assets/images/icons/material/designSystem/CoPresentFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ConfirmationNumber.js";
import "../../../../styles/assets/images/icons/material/designSystem/ConfirmationNumberFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ContactSupport.js";
import "../../../../styles/assets/images/icons/material/designSystem/ContactSupportFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ContentCopy.js";
import "../../../../styles/assets/images/icons/material/designSystem/CopyAll.js";
import "../../../../styles/assets/images/icons/material/designSystem/CreditCard.js";
import "../../../../styles/assets/images/icons/material/designSystem/CreditCardFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Dashboard.js";
import "../../../../styles/assets/images/icons/material/designSystem/DashboardFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Delete.js";
import "../../../../styles/assets/images/icons/material/designSystem/DeleteFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/DirectionsCar.js";
import "../../../../styles/assets/images/icons/material/designSystem/DirectionsCarFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/DirectionsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/DisabledByDefault.js";
import "../../../../styles/assets/images/icons/material/designSystem/DisabledByDefaultFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/DoNotDisturb.js";
import "../../../../styles/assets/images/icons/material/designSystem/Edit.js";
import "../../../../styles/assets/images/icons/material/designSystem/EditFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ElectricCar.js";
import "../../../../styles/assets/images/icons/material/designSystem/ElectricCarFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Error.js";
import "../../../../styles/assets/images/icons/material/designSystem/ErrorFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/EventFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ExpandContent.js";
import "../../../../styles/assets/images/icons/material/designSystem/ExpandLess.js";
import "../../../../styles/assets/images/icons/material/designSystem/ExpandMore.js";
import "../../../../styles/assets/images/icons/material/designSystem/Favorite.js";
import "../../../../styles/assets/images/icons/material/designSystem/FavoriteFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/FileCopy.js";
import "../../../../styles/assets/images/icons/material/designSystem/FileCopyFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/FilterAltFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/FirstPage.js";
import "../../../../styles/assets/images/icons/material/designSystem/Forward.js";
import "../../../../styles/assets/images/icons/material/designSystem/GarageHome.js";
import "../../../../styles/assets/images/icons/material/designSystem/GarageHomeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/GridView.js";
import "../../../../styles/assets/images/icons/material/designSystem/Group.js";
import "../../../../styles/assets/images/icons/material/designSystem/GroupFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Help.js";
import "../../../../styles/assets/images/icons/material/designSystem/HelpFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/HideSource.js";
import "../../../../styles/assets/images/icons/material/designSystem/Home.js";
import "../../../../styles/assets/images/icons/material/designSystem/HomeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Info.js";
import "../../../../styles/assets/images/icons/material/designSystem/InfoFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/IosShare.js";
import "../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowDown.js";
import "../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowLeft.js";
import "../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowRight.js";
import "../../../../styles/assets/images/icons/material/designSystem/KeyboardDoubleArrowUp.js";
import "../../../../styles/assets/images/icons/material/designSystem/LastPage.js";
import "../../../../styles/assets/images/icons/material/designSystem/Link.js";
import "../../../../styles/assets/images/icons/material/designSystem/ListAlt.js";
import "../../../../styles/assets/images/icons/material/designSystem/ListAltFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/LocalLibraryFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/LocationOn.js";
import "../../../../styles/assets/images/icons/material/designSystem/LocationOnFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/LockOpen.js";
import "../../../../styles/assets/images/icons/material/designSystem/LockReset.js";
import "../../../../styles/assets/images/icons/material/designSystem/Logout.js";
import "../../../../styles/assets/images/icons/material/designSystem/Loop.js";
import "../../../../styles/assets/images/icons/material/designSystem/Mail.js";
import "../../../../styles/assets/images/icons/material/designSystem/MailFilled.js";
import { ReactComponent as ForwardRef } from "../../../../styles/assets/images/icons/material/designSystem/Menu.js";
import "../../../../styles/assets/images/icons/material/designSystem/MonitorHeart.js";
import "../../../../styles/assets/images/icons/material/designSystem/MonitorHeartFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/MoreHoriz.js";
import "../../../../styles/assets/images/icons/material/designSystem/MoreVert.js";
import "../../../../styles/assets/images/icons/material/designSystem/NetworkCheck.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationImportant.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationImportantFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Notifications.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationsActive.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationsActiveFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationsOff.js";
import "../../../../styles/assets/images/icons/material/designSystem/NotificationsOffFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Paid.js";
import "../../../../styles/assets/images/icons/material/designSystem/PaidFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Pending.js";
import "../../../../styles/assets/images/icons/material/designSystem/Percent.js";
import "../../../../styles/assets/images/icons/material/designSystem/Person.js";
import "../../../../styles/assets/images/icons/material/designSystem/PersonAdd.js";
import "../../../../styles/assets/images/icons/material/designSystem/PersonAddFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PersonFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PhoneDisabled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PhoneDisabledFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PointOfSale.js";
import "../../../../styles/assets/images/icons/material/designSystem/PriceChange.js";
import "../../../../styles/assets/images/icons/material/designSystem/PriceChangeFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PriceCheck.js";
import "../../../../styles/assets/images/icons/material/designSystem/Publish.js";
import "../../../../styles/assets/images/icons/material/designSystem/PublishFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/PushPin.js";
import "../../../../styles/assets/images/icons/material/designSystem/PushPinFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/QuestionMark.js";
import "../../../../styles/assets/images/icons/material/designSystem/Receipt.js";
import "../../../../styles/assets/images/icons/material/designSystem/ReceiptFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Refresh.js";
import "../../../../styles/assets/images/icons/material/designSystem/RemoveCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/RemoveCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Replay.js";
import "../../../../styles/assets/images/icons/material/designSystem/Reply.js";
import "../../../../styles/assets/images/icons/material/designSystem/Restore.js";
import "../../../../styles/assets/images/icons/material/designSystem/Route.js";
import "../../../../styles/assets/images/icons/material/designSystem/Save.js";
import "../../../../styles/assets/images/icons/material/designSystem/SaveFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Schedule.js";
import "../../../../styles/assets/images/icons/material/designSystem/Search.js";
import "../../../../styles/assets/images/icons/material/designSystem/Security.js";
import "../../../../styles/assets/images/icons/material/designSystem/Settings.js";
import "../../../../styles/assets/images/icons/material/designSystem/SettingsFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Shield.js";
import "../../../../styles/assets/images/icons/material/designSystem/ShieldFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Smartphone.js";
import "../../../../styles/assets/images/icons/material/designSystem/SmartphoneFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Square.js";
import "../../../../styles/assets/images/icons/material/designSystem/SquareFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/SwapHorizontalCircle.js";
import "../../../../styles/assets/images/icons/material/designSystem/SwapHorizontalCircleFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/TableView.js";
import "../../../../styles/assets/images/icons/material/designSystem/Tune.js";
import "../../../../styles/assets/images/icons/material/designSystem/Undo.js";
import "../../../../styles/assets/images/icons/material/designSystem/Update.js";
import "../../../../styles/assets/images/icons/material/designSystem/Videocam.js";
import "../../../../styles/assets/images/icons/material/designSystem/VideocamFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/ViewList.js";
import "../../../../styles/assets/images/icons/material/designSystem/ViewListFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Visibility.js";
import "../../../../styles/assets/images/icons/material/designSystem/VisibilityFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/VisibilityOffFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/Warning.js";
import "../../../../styles/assets/images/icons/material/designSystem/WarningFilled.js";
import "../../../../styles/assets/images/icons/material/designSystem/WiFi.js";
import "../../../../styles/assets/images/icons/material/designSystem/WiFiOff.js";
import "../../../../styles/assets/images/icons/material/designSystem/Work.js";
import "../../../../styles/assets/images/icons/material/designSystem/WorkFilled.js";
import "../../../../styles/assets/images/icons/brands/GoogleG.js";
import { invokeFnAsync } from "../../../../utils/invokeFn.js";
import { noOp } from "../../../../utils/noOp.js";
import FlashAppSwitcherNavbarDesktop from "../FlashAppSwitcher/FlashAppSwitcherNavbarDesktop.js";
import { FLASH_NAVBAR_HEIGHT } from "../constants.js";
import "../../../../_commonjsHelpers-0c53d963.js";
import "../../../../sass/sass.js";
import "../../../atoms/info/FlashBadge/FlashBadge.js";
import "../../../atoms/info/FlashSpinner/FlashSpinner.js";
import "../../../atoms/buttons/FlashButtonGeneric.js";
import "../../../../index-5e4e4f4b.js";
import "../../../../axios-5f69b112.js";
import "../../../../Button-9f0631d3.js";
import "../../../../hooks/useInsights/useInsights.js";
import "../../../../hooks/useLogger/constants.js";
import "../../../../hooks/useLogger/useLogger.js";
import "../../../../hooks/useLogger/LoggerContext.js";
import "../../../../hooks/useLogger/types.js";
import "../../../../hooks/useInsights/InsightsContext.js";
import "../../../../hooks/useInsights/useInsightsImpression.js";
import "../../../../index-2d889c01.js";
import "../../../../hooks/useInsights/utils.js";
import "../../../atoms/buttons/FlashButton/constants.js";
import "../../../../hooks/useWindowSize/WindowSizeContext.js";
import "../../../../isObject-ec23ace2.js";
import "../../../../isSymbol-c6f5cd95.js";
import "../../../atoms/popups/FlashPopover/FlashPopover.js";
import "../../../../TooltipPopoverWrapper-c4dc3a40.js";
import "react-dom";
import "../../../../Popper-b45e70f5.js";
import "../../../../Manager-52cb3832.js";
import "../../../../Fade-1a465599.js";
import "../../../../Transition-c07376a3.js";
import "../../../../hooks/useOutsideClickHandler/useOutsideClickHandler.js";
import "../../../atoms/popups/FlashPopover/useFlashPopover.js";
import "../../../atoms/popups/FlashTooltip/FlashTooltip.js";
import "../../../../hooks/useFocusModal/FlashFocusModalTarget.js";
import "../../../../hooks/useFocusModal/useFocusModal.js";
import "../../../../hooks/useFocusModal/FocusModalContext.js";
import "../../../../i18n/index.js";
import "../../../../i18n/translations/en.js";
import "../../../../i18n/translations/es.js";
import "../../../../i18nInstance-89725fcb.js";
import "../FlashAppSwitcher/FlashAppSwitcherNavbarAppButtons.js";
import "../../../atoms/buttons/FlashButton/FlashButtonContentBrandIcon.js";
import "../../../atoms/icons/FlashBrandIcon/FlashBrandIcon.js";
import "../FlashAppSwitcher/constants.js";
import "../../../../useTranslation-cf39c293.js";
import "../FlashAppSwitcher/utils.js";
import "../../../../I18nextProvider-16dc4551.js";
var _excluded = ["className", "cssModule", "tag"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded), key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++)
      key = sourceSymbolKeys[i], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i;
  for (i = 0; i < sourceKeys.length; i++)
    key = sourceKeys[i], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
var propTypes = {
  /** Add custom class */
  className: PropTypes.string,
  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,
  /** Set a custom element for this component */
  tag: tagPropType
};
function NavbarBrand(props) {
  var className = props.className, cssModule = props.cssModule, _props$tag = props.tag, Tag = _props$tag === void 0 ? "a" : _props$tag, attributes = _objectWithoutProperties(props, _excluded), classes = mapToCssModules(classNames(className, "navbar-brand"), cssModule);
  return /* @__PURE__ */ React__default.createElement(Tag, _extends({}, attributes, {
    className: classes
  }));
}
NavbarBrand.propTypes = propTypes;
const FlashNavbarContext = createContext({
  mobileMenuIsOpen: !1,
  closeMobileMenu: noOp,
  navbarHeight: FLASH_NAVBAR_HEIGHT
});
function FlashNavbar(props) {
  const {
    logo,
    desktopAppSwitcher = { isHidden: !0, apps: [] },
    fixed = !0,
    navbarChildren,
    mobileMenuChildren,
    mobileMenuZIndex = 1,
    onNavbarHeightChange
  } = props, { isHidden: desktopAppSwitcherIsHidden, ...desktopAppSwitcherProps } = desktopAppSwitcher, { windowIsMobile } = useWindowSize(), { isOpen: mobileMenuIsOpen, toggle: toggleMobileMenu, close: closeMobileMenu } = useCollapse(), [navbarHeight, setNavbarHeight] = useState(FLASH_NAVBAR_HEIGHT);
  useEffect(
    function() {
      windowIsMobile || closeMobileMenu();
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps --
     *   should only fire on window size changes
     */
    [windowIsMobile]
  ), useEffect(
    function() {
      invokeFnAsync(onNavbarHeightChange, [navbarHeight]);
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps --
     *   should only fire on navbar height changes
     */
    [navbarHeight]
  );
  function navbarRef(node) {
    node && setNavbarHeight(`${node.getBoundingClientRect().height}px`);
  }
  return /* @__PURE__ */ jsx("div", { className: `${COMMON_CLASSNAME} flash-navbar`, children: /* @__PURE__ */ jsxs(FlashNavbarContext.Provider, { value: { navbarHeight, mobileMenuIsOpen, closeMobileMenu }, children: [
    /* @__PURE__ */ jsx("nav", { className: classNames("navbar shadow-flash-base bg-primary", { "fixed-top": fixed }), ref: navbarRef, children: /* @__PURE__ */ jsxs("div", { className: "d-flex w-100 align-items-center", children: [
      windowIsMobile && /* @__PURE__ */ jsx(
        FlashButton,
        {
          id: "flash-navbar-toggle-mobile-menu",
          LeadingIcon: ForwardRef,
          iconFontSize: "1.2rem",
          removePadding: !0,
          color: "icon_only_default",
          onClick: toggleMobileMenu,
          className: classNames("animated", {
            "fade-out": mobileMenuIsOpen,
            "fade-out-left": mobileMenuIsOpen,
            "me-flash-200": !mobileMenuIsOpen
          })
        }
      ),
      !windowIsMobile && !desktopAppSwitcherIsHidden && /* @__PURE__ */ jsx(FlashAppSwitcherNavbarDesktop, { ...desktopAppSwitcherProps }),
      /* @__PURE__ */ jsx(NavbarBrand, { href: "/", children: /* @__PURE__ */ jsx("img", { alt: "logo", src: logo, height: "22px" }) }),
      /* @__PURE__ */ jsx("span", { className: "flex-fill" }),
      /* @__PURE__ */ jsxs("div", { className: "d-flex", children: [
        /* @__PURE__ */ jsx(
          FlashButton,
          {
            id: "flash-navbar-close-mobile-menu",
            LeadingIcon: ForwardRef$1,
            removePadding: !0,
            color: "icon_only_default",
            onClick: closeMobileMenu,
            className: classNames("animated", {
              "fade-out": !mobileMenuIsOpen,
              "fade-out-right": !mobileMenuIsOpen
            })
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames("animated", {
              "fade-out": mobileMenuIsOpen,
              "fade-out-right": mobileMenuIsOpen
            }),
            children: navbarChildren
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ jsx(
      "div",
      {
        "data-testid": "flash-navbar-mobile-menu",
        className: classNames("position-absolute w-100 animated", {
          "fade-out-up": !mobileMenuIsOpen
        }),
        style: { marginTop: navbarHeight, height: `calc(100vh - ${navbarHeight})`, zIndex: mobileMenuZIndex },
        children: /* @__PURE__ */ jsx("div", { className: "h-100 bg-primary overflow-y-scroll", children: mobileMenuChildren })
      }
    )
  ] }) });
}
export {
  FlashNavbarContext,
  FlashNavbar as default
};
//# sourceMappingURL=FlashNavbar.js.map
